export enum PlanMasterCategory {
    Auto = 'auto',
    Commercial = 'commercial',
    Chip = 'chip',
    Dental = 'dental',
    Medicaid = 'medicaid',
    MedicaidManaged = 'medicaid managed',
    Medicare = 'medicare',
    MedicareSupplemental = 'medicare supplemental',
    MedicareAdvantage = 'medicare advantage',
    Military = 'military',
    TPA = 'tpa',
    WorkersComp = 'workers comp',
}
